import React, { useEffect, useMemo } from 'react';
import {
	Meta,
	useFamilyMemberUserDataQuery,
} from '../../../../graphql/graphql';
import Loading from '../../../BaseModule/Components/Loading';
import useMeta from '../../../Meta/Hooks/useMeta';
import useScope from '../../../BaseModule/Hooks/useScope';
import FamilyMemberProfileItem, {
	UserProfileItem,
} from './FamilyMemberProfileItem';
import { useAppContext } from '../../../../Services/AppContext';
import moment from 'moment';
import netteApiClient from '../../../../Services/NetteApiClient';

interface Props {
	userId: string;
}

const FamilyMemberProfile: React.FC<Props> = ({ userId }) => {
	const { data, isLoading, refetch, isFetching } = useFamilyMemberUserDataQuery(
		{
			id: userId,
		},
	);
	const { getMetaAsObject } = useMeta();
	const { isLatam } = useScope();
	// @ts-ignore
	const { dateFormatMoment, redirectToFamilyMemberProfileEdit } =
		useAppContext();

	useEffect(() => {
		refetch();
	}, []);

	const user = data?.user;

	const items: UserProfileItem[] = useMemo(() => {
		const temp: UserProfileItem[] = [];

		const profile = user?.profile;

		if (!user || !profile) {
			return temp;
		}

		const meta = getMetaAsObject(user?.meta as Meta[]);

		if (profile?.birthDate) {
			temp.push({
				title: 'base.shared.dateOfBirth',
				value: moment(profile.birthDate).format(dateFormatMoment),
			});
		}

		['taj', 'emso', 'pesel', 'jmbg'].forEach(key => {
			if (meta[key]) {
				temp.push({
					title: `component.userProfileEditComponent.${key}`,
					value: meta[key],
				});
			}
		});

		if (profile?.address?.formattedFullAddress) {
			temp.push({
				title: 'base.shared.address',
				value: profile.address.formattedFullAddress,
			});
		}

		if (profile?.insuranceCompanyTermItem) {
			temp.push({
				title: 'base.shared.insuranceCompany',
				value: `${profile.insuranceCompanyTermItem.value} - ${profile.insuranceCompanyTermItem.value2}`,
			});
		}

		if (profile?.formattedBirthNumber) {
			temp.push({
				title: isLatam ? 'base.typeOfInsurance' : 'base.shared.insuranceNumber',
				value: profile.formattedBirthNumber,
			});
		}

		return temp;
	}, [user]);

	const handleRedirectEdit = () => {
		netteApiClient.get(redirectToFamilyMemberProfileEdit);
	};

	if (isLoading || isFetching) {
		return <Loading />;
	}

	if (user) {
		return (
			<div className='user-profile-card'>
				<div className='user-profile-card__header'>
					<div className='user-profile-card__header__title'>
						{user.profile?.fullName}
					</div>
					{!user.isPatient && (
						<div className='user-profile-card__header__controls'>
							<div
								className='user-profile-card__header__controls__icon-wrapper'
								onClick={handleRedirectEdit}
							>
								<i className='fa-solid fa-pencil'></i>
							</div>
						</div>
					)}
				</div>
				<div className='user-profile-card__body'>
					{items.map((item, index) => (
						<FamilyMemberProfileItem item={item} key={index} />
					))}
				</div>
			</div>
		);
	}

	return <></>;
};

export default FamilyMemberProfile;
